// src/components/map/MapAreaErrorBoundary.jsx
//
// Explore's map area, contained (REM-703): an exception in MapView (a render,
// or a map-layer effect such as a call into a removed map) shows an error
// state with a reload in the map's place, not a blank app. MapPage renders it
// around MapView; the panels and bars outside the map area stay.
//
// The error goes to the console, not the page: a message can carry a dataset
// key. The way back is a full reload: the maps are gone with MapView, and a
// fresh load rebuilds them from a clean state.
import { Component } from "react";

export const MAP_ERROR_TEXT = "The map stopped because of an error.";

export default class MapAreaErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("[map] the map area failed", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" data-testid="map-area-error"
        className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-bg-soft p-6 text-center">
        <p className="text-sm text-fg-primary">{MAP_ERROR_TEXT}</p>
        <p className="text-sm text-fg-secondary">Reload the page to start the map again.</p>
        <button type="button" className="op-btn op-btn--sm" onClick={() => window.location.reload()}>Reload</button>
      </div>
    );
  }
}
